import { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { useParams } from 'react-router-dom'
import {
  isAllowedEnergyBusinessVertical,
  isAllowedInsuranceBusinessVertical,
  isAllowedTelecomBusinessVertical,
} from '@/containers/Login/AuthSelectors'

const useBusinessType = ({
  loaderRoutesEnergy = {},
  loaderRoutesInsurance = {},
  loaderRoutes = {},
  modulesStatuses = {},
  modulesStatusesEnergy = {},
  modulesStatusesInsurance = {},
}) => {
  const { type } = useParams()
  const isAllowedEnergyVertical = useSelector(isAllowedEnergyBusinessVertical)
  const isAllowedTelecomVertical = useSelector(isAllowedTelecomBusinessVertical)
  const isAllowedInsuranceVertical = useSelector(isAllowedInsuranceBusinessVertical)
  const getApplicationTypeFolder = () => {
    if (type === 'energie') {
      return 'Energy'
    }
    if (type === 'assurance') {
      return 'Insurance'
    }
    return 'Telecom'
  }
  const getApplicationRoutes = () => {
    if (type === 'energie') {
      return loaderRoutesEnergy ?? {}
    }
    if (type === 'assurance') {
      return loaderRoutesInsurance ?? {}
    }
    return loaderRoutes ?? {}
  }
  const getApplicationUrl = page => {
    const applicationPaths = getApplicationRoutes()
    return applicationPaths[page] ?? ''
  }
  const getModulesStatuses = applicationType => {
    if (applicationType === 'energie') {
      return modulesStatusesEnergy
    }
    if (applicationType === 'assurance') {
      return modulesStatusesInsurance
    }
    return modulesStatuses
  }

  const getApplicationMenuRoutes = applicationType => {
    if (applicationType === 'energie') {
      return {
        home: '/energie',
        overview: '/energie/subscription/list/overview',
        clientCallbacks: '/callbacks',
        form: '/energie/subscription/add',
        users: '/users-mngt',
        ipAddresses: '/ip-addresses-management',
        offices: '/energie/offices',
        providers: '/energie/organisations/provider',
        servicesStatus: '/energie/services-status',
        devTools: '/energie/dev-tools/tools',
        assistanceProducts: '/energie/additional-sales/assistance',
        monConseillerPersoProducts: '/energie/additional-sales/mon-conseiller-perso',
        carbonOffset: '/energie/additional-sales/carbon-offset',
        logout: '/logout',
      }
    }
    if (applicationType === 'assurance') {
      return {
        home: '/assurance',
        overview: '/assurance/subscription/list/overview',
        clientCallbacks: '/callbacks',
        form: '/assurance/subscription/add',
        users: '/users-mngt',
        ipAddresses: '/ip-addresses-management',
        providers: '/assurance/organisations/provider',
        servicesStatus: '/assurance/services-status',
        devTools: '/assurance/dev-tools/tools',
        assistanceProducts: '/assurance/additional-sales/assistance',
        monConseillerPersoProducts: '/assurance/additional-sales/mon-conseiller-perso',
        carbonOffset: '/assurance/additional-sales/carbon-offset',
        logout: '/logout',
      }
    }
    return {
      home: '/telecom',
      overview: '/telecom/subscription/list/overview',
      clientCallbacks: '/callbacks',
      form: '/telecom/subscription/add',
      users: '/users-mngt',
      ipAddresses: '/ip-addresses-management',
      providers: '/telecom/organisations/provider',
      providerOptions: '/telecom/provider-options',
      servicesStatus: '/telecom/services-status',
      devTools: '/telecom/dev-tools/tools',
      assistanceProducts: '/telecom/additional-sales/assistance',
      monConseillerPersoProducts: '/telecom/additional-sales/mon-conseiller-perso',
      carbonOffset: '/telecom/additional-sales/carbon-offset',
      logout: '/logout',
    }
  }

  const translateBusinessTypeToUrl = businessType => {
    if (businessType === 'energy') {
      return 'energie'
    }
    if (businessType === 'insurance') {
      return 'assurance'
    }
    return 'telecom'
  }

  useEffect(() => {
    if (!type) {
      document.title = 'HOP'
      return
    }

    document.title = 'HOP ' + type.toUpperCase()
  }, [])

  return {
    type,
    typeTranslated: getApplicationTypeFolder(type),
    getApplicationUrl,
    getApplicationMenuRoutes,
    getModulesStatuses,
    getApplicationTypeFolder,
    translateBusinessTypeToUrl,
    isAllowedEnergyVertical,
    isAllowedTelecomVertical,
    isAllowedInsuranceVertical,
  }
}

export default useBusinessType
